import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MdSnackBar } from '@angular/material';

import { TdDialogService, TdLoadingService } from '@covalent/core';

import { StorageService } from '../../services/storage.service';

import 'rxjs/add/operator/toPromise';

@Component({
  selector: 'sorter-form',
  providers: [StorageService],
  templateUrl: './formConfigContainer.component.html',
  styleUrls: ['./formConfigContainer.component.scss'],
})
export class SorterConfigContainerFormComponent implements OnInit {

  action: string;
  containerName: string;
  channel: string;
  storageName: string;
  sorterName: string;

  name: string;
  id: number;

  sorterContainerConfig: any = {};

  chipAddition: boolean = true;
  chipRemoval: boolean = true;

  private storage: any = null;
  private order: any = null;
  private mogid: string;
  storages: any[];
 
  constructor(private _storageService: StorageService,
              private _router: Router,
              private _route: ActivatedRoute,
              private _snackBarService: MdSnackBar,
              private _loadingService: TdLoadingService,
              private _dialogService: TdDialogService) {}

              
  goBack(): void {
    this._router.navigate(['/sorter']);
  }

  ngOnInit(): void {
    this._route.params.subscribe((params: {containerName: string, channel: string, storage: string, sorterName: string}) => {
      this.containerName = params.containerName;
      this.channel = params.channel;
      this.storage = params.storage;
      this.sorterName = params.sorterName;
      if (this.containerName && this.channel && this.storage && this.sorterName) {
        this.load();
      }
    });
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('sorter.form');
      this.sorterContainerConfig = await this._storageService.getSorterContainerConfig(this.containerName, this.channel, this.storage, this.sorterName).toPromise();
      const { name } = this.sorterContainerConfig.container;
      this.name = name;
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error loading the sorter container'});
    } finally {
      this._loadingService.resolve('sorter.form');
    }
  }


  async save(): Promise<void> {
    try {
      this._loadingService.register('sorter.form');    
      await this._storageService.updateSorterContainerConfig(this.storage,this.sorterName,this.sorterContainerConfig.channel,this.name).toPromise();
      this.goBack();
    } catch (error) {
      this._dialogService.openAlert({title: 'There was an error saving the config', message: error.message});
    } finally {
      this._loadingService.resolve('sorter.form');
    }
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/sorter/formConfigContainer/formConfigContainer.component.ts